import { Link, type LinkProps } from '../primitives/index.js'
import type { TypographyProps } from '../primitives/index.js'

export const ButtonLink = (props: LinkProps & Pick<TypographyProps, 'variant'>) => (
  <Link component="button" {...props} />
)

export default ButtonLink
